import { error, success, warning } from 'react-notification-system-redux';

import { notificationsConfig } from '../../../config/constants';
import { NotificationConfig } from '../../shared.types';

const getNotificationConfig = (message: string | NotificationConfig, interpolationValues?: any, isError?: boolean) =>
  typeof message === 'string'
    ? {
        translationKey: message,
        interpolationValues,
        ...(isError ? notificationsConfig.defaultErrorConf : notificationsConfig.defaultConf),
      }
    : message;

export const notificationError = (message: string | NotificationConfig, interpolationValues?: any) =>
  error(getNotificationConfig(message, interpolationValues, true));

export const notificationSuccess = (message: string | NotificationConfig, interpolationValues?: any) =>
  success(getNotificationConfig(message, interpolationValues));

export const notificationWarning = (message: string | NotificationConfig, interpolationValues?: any) =>
  warning(getNotificationConfig(message, interpolationValues, true));
